// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"55da2a08","977":"2892d5dc"}[chunkId] + ".chunk.js";
};